<template>
    <transition name="home-fade">
        <component :is="view" @loaded="mainLoaded"></component>
    </transition>
</template>

<script>
import homePage from "./Home.vue";
import loadingPage from "./Loading.vue";

export default {
    name: "index-page",

    components: {
        "home-page": homePage,
		"loading-page": loadingPage,
    },
    data: () => ({
        view: "home-page",
    }),
    created() {
        
    },
    mounted() {

    },
    watch: {
    },
    computed: {
    },
    methods: {
        mainLoaded(loaded) {
            if(loaded) {
                this.view = "home-page"
            }
        }
    },
};
</script>

<style lang="scss" scoped>

</style>
